<template>
  <!--
      作者 kmdshop
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">系统设置</div>
      <el-form-item
        label="系统名称"
        :rules="[{ required: true, message: ' ' }]"
        prop="name"
      >
        <el-input
          v-model="form.name"
          placeholder="系统名称"
          class="max-w460"
        ></el-input>
      </el-form-item>
      <el-form-item label="系统描述" prop="describe">
        <el-input
          v-model="form.describe"
          placeholder="系统描述"
          type="textarea"
          :rows="3"
          class="max-w460"
        ></el-input>
      </el-form-item>

      <el-form-item label="虚拟使用人数" prop="describe">
        <el-input
          v-model="form.people"
          placeholder="虚拟使用人数"
          type="number"
          class="max-w460"
        ></el-input>
      </el-form-item>

      <el-form-item label="联系方式" prop="phone">
        <el-input
          v-model="form.phone"
          placeholder="联系方式"
          type="number"
          class="max-w460"
        ></el-input>
      </el-form-item>

      <el-form-item label="系统LOGO" prop="describe">
        <div
          v-if="form.logo.file_path"
          class="default-image-box"
          @click="isAboutLogoUpload = true"
        >
          <div class="image-box">
            <img :src="form.logo.file_path" alt="product_default_image" />
            <a
              href="javascript:void(0);"
              class="delete-btn"
              @click.stop="deleteshareLogoImg"
            >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="isAboutLogoUpload = true">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="默认分享图" prop="describe">
        <div
          v-if="form.sharelogo.file_path"
          class="default-image-box"
          @click="isAboutshareLogoUpload = true"
        >
          <div class="image-box">
            <img :src="form.sharelogo.file_path" alt="product_default_image" />
            <a
              href="javascript:void(0);"
              class="delete-btn"
              @click.stop="deleteshareLogoImg"
            >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="isAboutshareLogoUpload = true">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="关于banner" prop="describe">
        <div
          v-if="form.about_banner.file_path"
          class="default-image-box"
          @click="isAboutBannerUpload = true"
        >
          <div class="image-box">
            <img
              :src="form.about_banner.file_path"
              alt="product_default_image"
            />
            <a
              href="javascript:void(0);"
              class="delete-btn"
              @click.stop="deleteImg"
            >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="isAboutBannerUpload = true">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <!-- <el-form-item label="配送方式">
        <el-checkbox-group v-model="form.checkedCities">
          <el-checkbox v-for="(item,index) in all_type" :label="item.value" :key="index">{{item.name}}</el-checkbox> -->
      <!-- <el-checkbox :label="10">快递配送</el-checkbox>
          <el-checkbox :label="20">上门自提</el-checkbox> -->
      <!-- </el-checkbox-group>
        <div class="tips">注：配送方式至少选择一个</div>
      </el-form-item> -->
      <!-- <el-form-item label="开启购物车" prop="is_open_cart"><el-switch v-model="form.is_open_cart"></el-switch></el-form-item> -->
      <!-- <el-form-item label="会员封禁提示" :rules="[{required: true,message: ' '}]" prop="msg">
        <el-input v-model="form.msg" placeholder="提示" class="max-w460"></el-input>
      </el-form-item> -->
      <div class="common-form">物流查询api</div>
      <el-form-item
        label="应用帐号"
        :rules="[{ required: false, message: ' ' }]"
        prop="customer"
      >
        <el-input
          v-model="form.kuaidi100.customer"
          placeholder=""
          class="max-w460"
        ></el-input>
        <div v-if="!w7" class="tips">
          用于查询物流信息,<el-link
            :underline="false"
            href="http://pm.y01.cn/v2/pm/login/"
            target="_blank"
            type="primary"
            >物流查询接口免费申请</el-link
          >
        </div>
        <div v-else class="tips">请联系管理员</div>
      </el-form-item>
      <el-form-item
        label="应用秘钥"
        :rules="[{ required: false, message: ' ' }]"
        prop="key"
      >
        <el-input
          v-model="form.kuaidi100.key"
          placeholder=""
          class="max-w460"
        ></el-input>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading"
          >提交</el-button
        >
      </div>
    </el-form>

    <!--商品图片组件-->
    <Upload
      v-if="isAboutBannerUpload"
      :config="{ total: 9 }"
      :isupload="isAboutBannerUpload"
      @returnImgs="returnProductImgsFunc"
      >上传图片</Upload
    >

    <!-- logo图片组件 -->
    <Upload
      v-if="isAboutLogoUpload"
      :config="{ total: 9 }"
      :isupload="isAboutLogoUpload"
      @returnImgs="returnLogoImgsFunc"
      >上传图片</Upload
    >
    <Upload
      v-if="isAboutshareLogoUpload"
      :config="{ total: 1 }"
      :isupload="isAboutshareLogoUpload"
      @returnImgs="returnshareLogoImgsFunc"
      >上传图片</Upload
    >
  </div>
</template>

<script>
import SettingApi from "@/api/setting.js";
import _ from "lodash";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      isAboutBannerUpload: false,

      isAboutLogoUpload: false,

      isAboutshareLogoUpload: false,
      /*form表单数据*/
      form: {
        name: "",
        describe: "",
        phone: "",

        about_banner: {
          file_id: "",
          file_path: ""
        },
        logo: {
          file_id: "",
          file_path: ""
        },
        sharelogo: {
          file_id: "",
          file_path: ""
        },
        msg: "",
        kuaidi100: {
          customer: "",
          key: ""
        },
        checkedCities: [
          /* 10, 20 */
        ],
        is_open_cart: true
      },
      w7: {},
      all_type: [],
      type: []
    };
  },
  created() {
    this.getParams();
  },

  methods: {
    /*获取配置数据*/
    getParams() {
      let self = this;
      SettingApi.storeDetail({}, true)
        .then(res => {
          if (res.code) {
            self.form.checkedCities = res.data.vars.values.delivery_type;
            let vars = res.data.vars.values;

            // 处理检修服务banner数据，如果是单个对象则转为数组
            if (vars.jx_banner && !Array.isArray(vars.jx_banner)) {
              vars.jx_banners = [
                {
                  title: vars.jx_banner.title || "",
                  file_id: vars.jx_banner.file_id || "",
                  file_path: vars.jx_banner.file_path || ""
                }
              ];
              delete vars.jx_banner;
            } else if (Array.isArray(vars.jx_banners)) {
              // 为数组中的每个元素添加id
              vars.jx_banners = vars.jx_banners.map(item => ({
                ...item
              }));
            }

            self.form = _.merge(self.form, res.data.vars.values);

            self.type = vars.delivery_type;
            self.all_type = res.data.all_type;
            self.w7 = res.data.w7;
            self.loading = false;
          } else {
            self.$message.error("错了哦，这是一条错误消息");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    /*提交*/
    onSubmit() {
      let self = this;
      let params = this.form;
      if (params.checkedCities.length < 1) {
        self.$message({
          message: "配送方式至少选择一种！",
          type: "warning"
        });
        return;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          SettingApi.editStore(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: "恭喜你，系统设置成功",
                type: "success"
              });
              self.$router.push("/setting/store/index");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    /*删除商品图片*/
    deleteImg() {
      this.form.about_banner = {
        file_id: "",
        file_path: ""
      };
    },
    deleteImg1() {
      this.form.jx_banner = {
        file_id: "",
        file_path: ""
      };
    },
    // 删除logo图片
    deleteLogoImg() {
      this.form.logo = {
        file_id: "",
        file_path: ""
      };
    },
    // 删除logo图片
    deleteshareLogoImg() {
      this.form.sharelogo = {
        file_id: "",
        file_path: ""
      };
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach(element => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach(e => {
            if (e === ext) {
              prevent = true;
              return false;
            }
          });
        });
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        this.form.about_banner.file_id = e[0].file_id;
        this.form.about_banner.file_path = e[0].file_path;
      }
      this.isAboutBannerUpload = false;
    },
    // 上传logo图片
    returnLogoImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach(element => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach(e => {
            if (e === ext) {
              prevent = true;
              return false;
            }
          });
        });
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        this.form.logo.file_id = e[0].file_id;
        this.form.logo.file_path = e[0].file_path;
      }
      this.isAboutLogoUpload = false;
    },
    returnshareLogoImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach(element => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach(e => {
            if (e === ext) {
              prevent = true;
              return false;
            }
          });
        });
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        this.form.sharelogo.file_id = e[0].file_id;
        this.form.sharelogo.file_path = e[0].file_path;
      }
      this.isAboutshareLogoUpload = false;
    }
  }
};
</script>

<style scoped lang="scss">
.tips {
  color: #ccc;
}

.img-select {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 10px;

  i {
    display: flex;
    line-height: 110px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed #dddddd;
    font-size: 30px;
    color: #409eff;
  }
}

.image-box {
  width: 110px;
  height: 110px;
  overflow: hidden;

  img {
    width: 110px;
    //height: 110px;
  }
}

.image-box:hover .delete-btn {
  display: block;
}

.default-image-box {
  position: relative;
  width: 110px;
  height: 110px;
}

.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/store/index.vue